import React, {useCallback, useMemo, useState} from "react";
import {List, PageButton, PageInput, PageInputContainer, ArrowButton} from './styles';
import arrowImage from './images/arrow.png';

const Paginator = ({ data, onPageChange }) => {
  const [inputPage, setInputPage] = useState('');

  const handleInputChange = useCallback((e) => {
    setInputPage(e.target.value);
  }, []);

  const handlePageSubmit = useCallback(() => {
    const page = parseInt(inputPage, 10);
    if (page && page > 0 && page <= data.last_page) {
      onPageChange(page);
      setInputPage('');
    }
  }, [inputPage, data.last_page, onPageChange]);

  const pages = useMemo(() => {
    if (!data.current_page || data.last_page <= 1) {
      return null;
    }

    const { current_page, last_page } = data;
    const result = [];
    let leftDots = true;
    let rightDots = true;

    for (let page = 1; page <= last_page; page++) {
      const isCurrent = page === current_page;
      const isAdjacent = page === current_page - 1 || page === current_page + 1;
      const isEdge = page === 1 || page === last_page;

      if (isCurrent || isAdjacent || isEdge) {
        result.push({
          type: 'page',
          page,
          isCurrent,
          key: `page-${page}`
        });
      } else if (page > current_page + 1 && rightDots) {
        rightDots = false;
        result.push({
          type: 'dots',
          key: `dots-right-${page}`
        });
      } else if (page < current_page - 1 && leftDots) {
        leftDots = false;
        result.push({
          type: 'dots',
          key: `dots-left-${page}`
        });
      }
    }

    return result;
  }, [data.current_page, data.last_page]);

  const handlePageClick = useCallback((page) => {
    onPageChange(page);
  }, [onPageChange]);

  const handlePrevPage = useCallback(() => {
    if (data.current_page > 1) {
      onPageChange(data.current_page - 1);
    }
  }, [data.current_page, onPageChange]);

  const handleNextPage = useCallback(() => {
    if (data.current_page < data.last_page) {
      onPageChange(data.current_page + 1);
    }
  }, [data.current_page, data.last_page, onPageChange]);

  if (!pages) {
    return null;
  }

  return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <ArrowButton
            onClick={handlePrevPage}
            disabled={data.current_page <= 1}
            title="Предыдущая страница"
        >
          <img src={arrowImage} alt="Назад" />
        </ArrowButton>
        <List>
          {pages.map((item) => (
              item.type === 'page' ? (
                  <li key={item.key} id={item.key} className={item.isCurrent ? 'active' : ''}>
                    <a onClick={() => handlePageClick(item.page)}>{item.page}</a>
                  </li>
              ) : (
                  <li key={item.key}>
                    <a>...</a>
                  </li>
              )
          ))}
        </List>
        <PageInputContainer>
        <ArrowButton
            onClick={handleNextPage}
            disabled={data.current_page >= data.last_page}
            title="Следующая страница"
        >
          <img src={arrowImage} alt="Вперед" style={{ transform: 'rotate(180deg)' }} />
        </ArrowButton>
          <PageInput
              value={inputPage}
              onChange={handleInputChange}
              placeholder="стр."
          />
          <PageButton onClick={handlePageSubmit}>перейти</PageButton>
        </PageInputContainer>
    
      </div>
  );
};

export default React.memo(Paginator);